// src/auth/AuthCallback.jsx
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";

/**
 * Neutral MSAL callback screen.
 * MSAL Provider will process the hash on this route; do not navigate away.
 */
export default function AuthCallback() {
    const { inProgress } = useMsal();
    const msg = inProgress === InteractionStatus.None ? "Finalizing sign-in�" : "Signing you in�";
    return (
        <div className="main">
            <div className="card">{msg}</div>
        </div>
    );
}
